import { render } from "./FormRichedit.vue?vue&type=template&id=63d46b5b&scoped=true&ts=true"
import script from "./FormRichedit.vue?vue&type=script&lang=ts"
export * from "./FormRichedit.vue?vue&type=script&lang=ts"

import "./FormRichedit.vue?vue&type=style&index=0&id=63d46b5b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d46b5b"]])

export default __exports__